import Vue from 'www/vue_components'
import initI18n from 'www/utils/executors/initI18n'
import I18NextVue from 'i18next-vue'
import vuetify from 'www/modules/vuetify-plugin'
import ChooseTownDialog from 'www/vue_components/desktop/ChooseTownDialog/ChooseTownDialog.vue'

const mountNode = document.querySelector('#choose-town-dialog')

async function initChooseTownDialog() {
  if (mountNode) {
    const { i18next } = await initI18n({ bundle: 'vue_components/desktop/ChooseTownDialog' })

    Vue.use(I18NextVue, i18next)

    new Vue({
      el: mountNode,
      vuetify,
      render: h => h(ChooseTownDialog),
    })
  }
}

initChooseTownDialog()
